import dayjs from 'dayjs';
import { ITaxTariffTranche } from 'app/shared/model/tax-tariff-tranche.model';

export interface ITaxTariffTrancheHistory {
  id?: number;
  tariff?: number | null;
  effectiveDate?: dayjs.Dayjs | null;
  expirationDate?: dayjs.Dayjs | null;
  taxTariffTrancheType?: ITaxTariffTranche | null;
}

export const defaultValue: Readonly<ITaxTariffTrancheHistory> = {};
